import EditorEnlace from 'features/enlaces/components/EditorEnlace'

const EdicionEnlaces = () => {
  return <EditorEnlace />
}

export default EdicionEnlaces
